import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Constants from '../../config/constants';
import SearchBar from '../datatable/SearchBar';
import RelationDataTable from '../datatable/RelationDataTable';
import Thumbnail from '../thumbnail/Thumbnail';
import { COLUMN_STYLE, getColumnStyle } from '../datatable/util';

import {
  defaultRejectHandler, getStatusStyle,
  stringifyErrorMessage,
} from '../../utils/utility';

import {
  listACSplitTypeInZone,
  addACSplitTypeToZone,
  editACSplitTypeInZone,
  removeACSplitTypeFromZone,
} from '../../redux/zone/zone_ac_split_type_actions';
import { searchACSplitTypeByText } from '../../redux/ac_split_type/ac_split_type_actions';


export class ACSplitTypeDataTable extends React.Component {
  constructor(props) {
    super(props);

    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    this.state = {
      categoryOption: 'all',
      isShowCreateModal: false,
      isShowEditModal: false,
      isShowDeleteModal: false,
      isDuplicateModal: false,
    };
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;

    this.props.listACSplitType(
      this.search.pageSize,
      this.search.page,
      this.search.sorted,
      this.search.filtered,
      {
        all: null,
        public: true,
        private: false,
      }[category],
    );

    this.setState({ categoryOption: category });
  }

  render() {
    const { categoryOption } = this.state;

    const {
      zoneId,
      acSplitTypeList,
      filteredCount,
      isLoading,
      addACSplitTypeToZone,
      editACSplitTypeInZone,
      removeACSplitTypeFromZone,
      isACSplitTypeAdding,
      isACSplitTypeEditing,
      isACSplitTypeRemoving,
      errorMessage,
      t,
    } = this.props;

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coeColumn = getColumnStyle(COLUMN_STYLE.coefficient);

    const columns = [
      {
        Header: '',
        accessor: 'air_conditioning_split.thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'air_conditioning_split.name',
        ...textColumn,
        entity: {
          list: (text, page) => searchACSplitTypeByText(text, page, zoneId)
            .then(response => response.data.map(({name, id}) => ({label: name, value: String(id)}))),
        },
      },
      {
        Header: () => <b>{t('type')}</b>,
        accessor: 'air_conditioning_split.type',
        ...textColumn,
        width: 120,
      },
      {
        id: 'coolingCapacity',
        Header: () => <b>{t('cooling capacity')}</b>,
        accessor: row => `${row.air_conditioning_split.cooling_capacity} ${row.air_conditioning_split.unit}`,
        ...textColumn,
        width: 100,
      },
      {
        Header: () => <b>{t('power (kW)')}</b>,
        accessor: 'air_conditioning_split.power_required',
        ...coeColumn,
        width: 100,
      },
      {
        Header: () => <b>{t('COP')}</b>,
        accessor: 'air_conditioning_split.COP',
        ...coeColumn,
        width: 80,
      },
      {
        Header: () => <b>{t('SEER')}</b>,
        accessor: 'air_conditioning_split.SEER',
        ...coeColumn,
        width: 80,
      },
      {
        Header: () => <b>{t('compliance')}</b>,
        accessor: 'air_conditioning_split.compliance',
        ...coeColumn,
        width: 80,
      },
      {
        Header: () => <b>{t('status')}</b>,
        accessor: 'air_conditioning_split.status',
        Cell: row => <span className={getStatusStyle(row.value)}>{t(String(row.value).toLowerCase())}</span>,
        width: 70,
        ...textColumn,
      },
      {
        Header: () => <b>{t('quantity')}</b>,
        accessor: 'quantity',
        ...textColumn,
        width: 80,
        attr: {
          type: 'number',
          isRequired: true,
          props: { min: 1 },
        },
      },
    ];

    const relationship = {
      create: ({ entityId, quantity }) => addACSplitTypeToZone(entityId, quantity),
      edit: ({ id, quantity }) => editACSplitTypeInZone(id, quantity),
      delete: id => removeACSplitTypeFromZone(id),
      isCreating: isACSplitTypeAdding,
      isEditing: isACSplitTypeEditing,
      isDeleting: isACSplitTypeRemoving,
    };

    return (
      <div style={{ backgroundColor: 'white' }}>
        <SearchBar onSearch={text => this.updateSortFilter(text, null, this.state.categoryOption)} />
        <RelationDataTable
          columns={columns}
          data={acSplitTypeList}
          errorMessage={stringifyErrorMessage(errorMessage)}
          relationship={relationship}
          relationshipNameAccessor={item => item.air_conditioning_split.name}
          onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedItem: item.original })}
          filteredCount={filteredCount}
          isLoading={isLoading}
          onFetchData={state => this.updateSortFilter(this.search.filtered, state, this.state.categoryOption)}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  acSplitTypeList: state.zoneACSplitType.orderedIds.map(id => state.zoneACSplitType.objects[id]),
  isLoading: state.zoneACSplitType.isLoading,
  isACSplitTypeAdding: state.zoneACSplitType.isCreating,
  isACSplitTypeEditing: state.zoneACSplitType.isEditing,
  isACSplitTypeRemoving: state.zoneACSplitType.isDeleting,
  errorMessage: state.zoneACSplitType.errorMessage,
});

const mapDispatchToProps = (dispatch, ownedProps) => ({
  listACSplitType: (pageSize, page, sorted, filtered, isPublic) =>
    defaultRejectHandler(dispatch(listACSplitTypeInZone(pageSize, page, sorted, filtered, isPublic, ownedProps.zoneId))),
  addACSplitTypeToZone: (ahuId, quantity) =>
    defaultRejectHandler(dispatch(addACSplitTypeToZone(ahuId, ownedProps.zoneId, quantity))),
  editACSplitTypeInZone: (id, quantity) =>
    defaultRejectHandler(dispatch(editACSplitTypeInZone(id, quantity))),
  removeACSplitTypeFromZone: id =>
    defaultRejectHandler(dispatch(removeACSplitTypeFromZone(id))),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(ACSplitTypeDataTable),
);



// WEBPACK FOOTER //
// ./src/components/zone/ACSplitTypeDataTable.js